/** 상세 `message` 상한 (행의 `ERROR_MESSAGE_MAX` 200 보다 길게). */
export const ERROR_DETAIL_MESSAGE_MAX = 1000;
/** 공급자 응답 본문·스택 상한. */
export const ERROR_DETAIL_BODY_MAX = 2000;
/** 요청 요약(`requestSummary`) 상한. */
export const ERROR_DETAIL_SUMMARY_MAX = 500;
/** 키오스크 `url` 상한. */
export const ERROR_DETAIL_URL_MAX = 200;
/** 키오스크 `serverCode` 상한. */
export const ERROR_DETAIL_CODE_MAX = 80;
/** 손님 사진이 메시지에 섞여 들어오는 것을 막는 패턴 — 업로드 실패 메시지에 `data:image/jpeg;base64,…` 가 담기는 경우. */
const DATA_URL_RE = /data:[^\s"')]+/g;
const BASE64_RE = /base64,[A-Za-z0-9+/=]+/g;
/** API 키·토큰 패턴 — 공급자 오류 본문·요청 URL 에 섞일 수 있다. */
const QUERY_KEY_RE = /([?&](?:key|api_key|apikey|token|access_token)=)[^&\s"')]+/gi;
const BEARER_RE = /\bBearer\s+[A-Za-z0-9._~+/=-]+/g;
const GOOG_KEY_RE = /(x-goog-api-key\s*[:=]\s*)[^\s,;"')]+/gi;
const GOOG_TOKEN_RE = /\bAIza[0-9A-Za-z_-]{20,}/g;
const XAI_TOKEN_RE = /\bxai-[0-9A-Za-z_-]{20,}/g;
function redact(text) {
    return text
        .replace(DATA_URL_RE, "[data]")
        .replace(BASE64_RE, "[data]")
        .replace(QUERY_KEY_RE, "$1[redacted]")
        .replace(BEARER_RE, "Bearer [redacted]")
        .replace(GOOG_KEY_RE, "$1[redacted]")
        .replace(GOOG_TOKEN_RE, "[redacted]")
        .replace(XAI_TOKEN_RE, "[redacted]");
}
/**
 * 임의의 값을 로그에 남길 한 줄 텍스트로 정제한다 — 멱등.
 * - `Error` 는 `이름: 메시지`(이름이 "Error" 면 메시지만), 문자열은 그대로, 객체는 JSON, 그 외는 `String()`
 * - dataURL·base64 본문 → `[data]`, 쿼리/헤더의 API 키·Bearer 토큰·`AIza…`·`xai-…` → `[redacted]`
 * - 공백을 한 칸으로 모으고 `max` 자로 자른다
 */
export function sanitizeErrorText(raw, max) {
    let text;
    if (raw instanceof Error)
        text = raw.name && raw.name !== "Error" ? `${raw.name}: ${raw.message}` : raw.message;
    else if (typeof raw === "string")
        text = raw;
    else if (raw === undefined || raw === null)
        text = "";
    else if (typeof raw === "object") {
        try {
            text = JSON.stringify(raw);
        }
        catch {
            text = String(raw);
        }
    }
    else
        text = String(raw);
    return redact(text).replace(/\s+/g, " ").trim().slice(0, max);
}
/**
 * 스택은 줄바꿈이 의미가 있어 공백을 한 칸으로 모으지 않고 줄 단위로 정제한다.
 * `Error` 는 `stack`(없으면 메시지), 문자열은 그대로. 빈 줄을 버리고 전체를 `max` 자로 자른다.
 */
export function sanitizeStackText(raw, max = ERROR_DETAIL_BODY_MAX) {
    const text = raw instanceof Error ? (raw.stack ?? raw.message) : typeof raw === "string" ? raw : "";
    return redact(text)
        .split("\n")
        .map((line) => line.replace(/\s+/g, " ").trim())
        .filter((line) => line.length > 0)
        .join("\n")
        .slice(0, max);
}
//# sourceMappingURL=activity-error.js.map